/* global qs, getAncestor, numLock, getElementByName, getQuery *//* util.polyfil */
(function() {
    /* jshint validthis: true */
    "use strict";
    
    var lang = lang || document.documentElement.lang;
    var submittingForm = false;
    
    var checkoutForm;
    var mapMinQty = {};
    
    function reloadPage() {
        window.location.reload();
    }
    
    function preventSubmit(e) {
        e.preventDefault();
        return false;
    }
    
    function openMenuCatalog(e) {
        var btn = e.currentTarget || e.target;
        var el = qs(".checkout-menu-list[data-id='" + btn.getAttribute("data-id") + "']");

        removeClassAll(qsa(".open", btn.parentElement), "open");
        removeClassAll(qsa(".open", el.parentElement), "open");
        addClass(btn, "open");
        addClass(el, "open");
    }
    
    function toggleMenuProducts(e) {
        toggleAccordion(e.currentTarget || e.target);
    }
    
    function increaseCartProductQty(e) {
        var it = e.currentTarget || e.target;
        updateCartProductQty(it, 1);
    }
    function decreaseCartProductQty(e) {
        var it = e.currentTarget || e.target;
        updateCartProductQty(it, -1);
    }
    function updateCartProductQty(el, quantifier) {
        var inp = qs(".cmc-product-qty-input", getAncestor(el, "cmc-product-qty"));
        var qty = parseInt(inp.value);
        var min = mapMinQty[inp.getAttribute("data-id")];
        
        if (isNaN(qty) || (qty <= 0 && quantifier < 0)) {
            // Invalid number
            return false;
        }
        // Modify the quantity value of the input and update the cart
        qty += quantifier;
        if (qty < min) {
            qty = quantifier < 0 ? 0 : min;
        }
        inp.value = qty;
        addCart.call(inp, {type: "click", currentTarget: inp});
    }
    
    function addCart(e) {
        var inp = e.currentTarget || e.target;
        var curCat = qs(".checkout-menu-category.open");
        var qty = parseInt(inp.value);
        var min = mapMinQty[inp.getAttribute("data-id")];
        
        if (qty === 0 || qty >= min) {
            siteAjax("/action/ajaxAddCart?override=true&ids=" + inp.getAttribute("data-id") + "&quantities=" + inp.value, function(response) {
                var count = 0;
                // Sum up the quantities in the open menu
                each(qsa(".cmc-product-qty-input", getAncestor(inp, "checkout-menu-list")), function(el, i) {
                    count += isNaN(el.value) ? 0 : parseInt(el.value);
                });
                // Set the total on the category button
                qs(".cart-qty", curCat).innerHTML = count > 0 ? " (" + count + ")" : "";
            });
        }
    }
    
    function checkoutStep1(e) {
        var btn = e.currentTarget || e.target;
        var ctn = getAncestor(btn, "checkout-right-ctn");
        var fields = qsa("input, textarea", ctn);
        var completeCount = fields.length + 1;
        var validQties = true;
        
        // Check legit product quantity inputs
        each(qsa(".cmc-product-qty-input", getForm(btn)), function(el) {
            var qty = parseInt(el.value);
            var min = mapMinQty[el.getAttribute("data-id")];
            
            if (qty !== 0 && qty < min) {
                validQties = false;
                $(".errmsg-quantity", ctn).show();
                return;
            }
        });
        
        // Check delivery date
        // Noted format day/systemic month/full year
        var disabledDates = ["23/5/2021", "24/5/2021", "25/5/2021"];
        var dateValue = qs(".datetimepicker-dd", ctn).value + "/" + qs(".datetimepicker-dm", ctn).value + "/" + qs(".datetimepicker-dy", ctn).value;
        var validDate = disabledDates.indexOf(dateValue) === -1;
        
        if (!validDate) {
            getElementByName(ctn, "deliveryDate").value = "";
        }
        
        // Check required fields
        if (validQties && chkReqFields(ctn) && !submittingForm && validDate) {
            submittingForm = true;
            // Verify the cart
            siteAjax("/action/shopJsonCart", function(response) {
                var oCart = {};
                try {
                    oCart = JSON.parse(response);
                } catch (err) {
                }
                // Handle empty cart error
                if (oCart[1] && oCart[1].items !== "0") {
                    $(".errmsg-emptycart", ctn).hide();
                    $(".errmsg-quantity", ctn).hide();
                    // Save all values in the SessionVariables for step 2
                    each(fields, function(el, i) {
                        if (el.type === "checkbox" || el.type === "radio") {
                            if (el.checked) {
                                updateSVar(el.name, el.value, _complete);
                            } else {
                                _complete();
                            }
                        } else {
                            updateSVar(el.name, el.value, _complete);
                        }
                    });
                    // Set the step to 2
                    updateSVar("checkoutStep", "2", _complete);
                } else {
                    submittingForm = false;
                    $(".errmsg-emptycart", ctn).show();
                }
            });
        }
        
        function _complete() {
            completeCount--;
            if (completeCount <= 0) {
                ajaxBlackout(true);
                reloadPage();
            }
        }
    }
    
    function checkoutStep2(e) {
        var btn = e.currentTarget || e.target;
        var ctn = getAncestor(btn, "checkout-right-ctn");
        
        // Check required fields
        if (chkReqFields(ctn) && !submittingForm) {
            submittingForm = true;
            ajaxBlackout(true);
            
            // Append other required inputs
            var hiddenCtn = ctn.firstElementChild;
            var billStreetString = getElementByName(ctn, 'street').value;
            appendElement("<input type='hidden' name='billFirstName' value='" + getElementByName(ctn, "firstName").value + "'/>", hiddenCtn);
            appendElement("<input type='hidden' name='billLastName' value='" + getElementByName(ctn, "lastName").value + "'/>", hiddenCtn);
            appendElement("<input type='hidden' id='billStreetValue' name='billStreet' value=''/>", hiddenCtn);
            document.getElementById("billStreetValue").value = billStreetString; 
            appendElement("<input type='hidden' name='billCity' value='" + getElementByName(ctn, "city").value + "'/>", hiddenCtn);
            appendElement("<input type='hidden' name='billZip' value='" + getElementByName(ctn, "zip").value + "'/>", hiddenCtn);
            appendElement("<input type='hidden' name='state' value='QC'/>", hiddenCtn);
            appendElement("<input type='hidden' name='billState' value='QC'/>", hiddenCtn);
            appendElement("<input type='hidden' name='country' value='CA'/>", hiddenCtn);
            appendElement("<input type='hidden' name='billCountry' value='CA'/>", hiddenCtn);
            appendElement("<input type='hidden' name='cheque' value='true'/>", hiddenCtn);
            
            // Ready to submit the form
            var form = getAncestor(btn, "checkout-form");
            form.setAttribute("method", "post");
            form.setAttribute("action", "/action/shopSingleTransact");
            setTimeout(function() {
                form.submit();
            }, 20);
        }
    }
    
    function appendElement(html, target) {
        var el = document.createElement("DIV");
        el.innerHTML = html;
        target.appendChild(el.firstElementChild);
    }
    
    function checkoutBackStep() {
        if (!submittingForm) {
            submittingForm = true;
            updateSVar("checkoutStep", "1", reloadPage);
        }
    }

    // Pre-initiate
    DOMInit("interactive", function(e) {
        checkoutForm = qs(".checkout-form");
        if (!checkoutForm) {
            return;
        }
        var step = checkoutForm.getAttribute("data-step");
        
        bindEvent(checkoutForm, "submit", preventSubmit);
        
        // Step 1
        bindEvent(".checkout-step1-next", "click", checkoutStep1);
        bindEvent(".checkout-menu-category", "click", openMenuCatalog);
        bindEvent(".checkout-menu-catalog-head", "click", toggleMenuProducts);
        bindEvent(".cmc-product-qty-plus", "click", increaseCartProductQty);
        bindEvent(".cmc-product-qty-minus", "click", decreaseCartProductQty);
        var qtyInputs = qsa(".cmc-product-qty-input", checkoutForm);
        bindEvent(qtyInputs, "keypress", numLock);
        bindEvent(qtyInputs, "input", addCart);
        // Map the minimum quantity of the products
        each(qtyInputs, function(el) {
            try {
                mapMinQty[el.getAttribute("data-id")] = parseInt(el.min || el.getAttribute("min"));
            } catch (err) {
                mapMinQty[el.getAttribute("data-id")] = 0;
            }
        });
        
        // Step 2
        bindEvent(".checkout-step2-next", "click", checkoutStep2);
        bindEvent(".checkout-step2-prev", "click", checkoutBackStep);
        
        // Step 3 
        // If we arrive at the comfirmation page, it's a success
        // We set the current step to 3 in the SessionVariable
        if (typeof getQuery("success") === "string" && qs(".checkout-confirm-cart") && step !== "3") {
            updateSVar("checkoutStep", "3");
        }
    });

})();